module.exports = __webpack_public_path__ + "static/media/content_3.ce2c7ad2.svg";